import { SVGProps } from "react";

const BatteryLow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-batería-baja"
      {...props}
    >
      <path
        d="M22.167 11.5V13.5M6.16699 11.5V13.5M4.16699 7.5H16.167C17.2716 7.5 18.167 8.39543 18.167 9.5V15.5C18.167 16.6046 17.2716 17.5 16.167 17.5H4.16699C3.06242 17.5 2.16699 16.6046 2.16699 15.5V9.5C2.16699 8.39543 3.06242 7.5 4.16699 7.5Z"
        stroke="#FAFAFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BatteryLow;
